export const COUNTRIES = [
  { code: "US", name: "United States" },
  { code: "UK", name: "United Kingdom" },
  { code: "DE", name: "Germany" },
  { code: "CN", name: "China" },
  { code: "ZA", name: "South Africa" },
];
